var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F3F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4 7.8C13.4 6.80589 14.2059 6 15.2 6C16.1941 6 17 6.80589 17 7.8C17 8.58373 16.4991 9.25048 15.8 9.49758V14.5024C16.4991 14.7495 17 15.4163 17 16.2C17 17.1941 16.1941 18 15.2 18C14.2059 18 13.4 17.1941 13.4 16.2C13.4 16.1721 13.4006 16.1444 13.4019 16.1168L8.07931 13.8662C7.75307 14.1958 7.30038 14.4 6.8 14.4C5.80589 14.4 5 13.5941 5 12.6C5 11.6059 5.80589 10.8 6.8 10.8C7.23121 10.8 7.62701 10.9516 7.93698 11.2045L13.4345 8.15258C13.4119 8.03856 13.4 7.92067 13.4 7.8ZM15.2 7.2C14.8686 7.2 14.6 7.46863 14.6 7.8C14.6 8.13137 14.8686 8.4 15.2 8.4C15.5314 8.4 15.8 8.13137 15.8 7.8C15.8 7.46863 15.5314 7.2 15.2 7.2ZM8.56194 12.23C8.58689 12.3494 8.6 12.4732 8.6 12.6C8.6 12.6607 8.597 12.7207 8.59113 12.7798L13.8539 15.005C14.054 14.7797 14.31 14.6049 14.6 14.5024V9.49758C14.3972 9.42589 14.2111 9.31889 14.049 9.18396L8.56194 12.23ZM14.6 16.2C14.6 15.8686 14.8686 15.6 15.2 15.6C15.5314 15.6 15.8 15.8686 15.8 16.2C15.8 16.5314 15.5314 16.8 15.2 16.8C14.8686 16.8 14.6 16.5314 14.6 16.2ZM6.2 12.6C6.2 12.2686 6.46863 12 6.8 12C7.13137 12 7.4 12.2686 7.4 12.6C7.4 12.9314 7.13137 13.2 6.8 13.2C6.46863 13.2 6.2 12.9314 6.2 12.6Z",
    fill: "#E2E8F0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.446cb4773d07e163fd465d1f71372744.svg";
export { ForwardRef as ReactComponent };